import { styled } from "@woba/ds-web";

export const ProductItem = styled("div", {
  span: {
    fontSize: "$sm",
    fontWeight: 500,
    color: "$neutral-700",
    textTransform: "uppercase",
  },
});
export const ProductItemValue = styled("div", {
  display: "flex",
  alignItems: "baseline",

  span: {
    fontSize: "$sm",
    fontWeight: 500,
    color: "$neutral-900",
    maxWidth: "1rem",
  },
  p: {
    color: "$neutral-900",
    fontWeight: 500,
    marginLeft: "$space-02",
  },
});
